module.exports = __webpack_public_path__ + "img/goblin.04772788.svg";